import React, { useContext } from "react";
import { Link } from "react-router-dom";
import logo from "../assets/images/DSB-Logo.svg";
import divider from "../assets/images/divider.png";
import { MainLogo } from "../shared/MainLogo";
import styles from "../css/footer.module.css";
import AppContext from "../contexts/appContext";

export default function Footer() {
  const { menu } = useContext(AppContext);

  const showFAQ = false;
  const showTestimonials = false;

  return (
    <section className="flex flex-col self-center container px-16 lg:px-36">
      <img className="mx-auto my-10" src={divider} alt="Divider" />
      <div className="flex flex-col lg:flex-row max-sm:flex-col justify-between">
        <div className="basis-1/2 lg:basis-1/2 sm:basis-1">
          <img
            className="flex-none"
            src={logo}
            alt="DailySocialBoost Logo"
            height={200}
            width={200}
          />
          <div className="flex-none my-3">
            <div className="flex flex-row">
              {menu
                ? menu.map((service, index) => (
                    <Link
                      key={service.id + Math.random()}
                      className="m-1 flex-none hover:opacity-75 transition-all"
                      to={`/services/${service.id}`}
                    >
                      {" "}
                      {MainLogo().MainLogo(service.name.toLowerCase())}
                    </Link>
                  ))
                : null}
            </div>
          </div>
        </div>
        <div className="basis-1 lg:basis-2/3 max-sm:basis-1">
          <div className="flex flex-col md:flex-row max-sm:flex-col justify-between lg:justify-between max-sm:justify-center gap-x-3 gap-y-0 max-sm:gap-y-5">
            <div className="flex flex-col basis-1 lg:basis-1/3">
              <h3 className="flex-none uppercase text-lg font-bold text-pink-350 clear-both">
                Dailysocialboost
              </h3>
              <ul className="flex flex-col uppercase">
                <li className="flex-none transition-all">
                  <Link className="hover:text-pink-350" to="/">
                    Home
                  </Link>
                </li>
                <li className="flex-none transition-all">
                  <Link className="hover:text-pink-350" to="/blog">
                    Blog
                  </Link>
                </li>
                {showFAQ ? (
                  <li className="flex-none transition-all">
                    <Link className="hover:text-pink-350" to="/faq">
                      FAQ
                    </Link>
                  </li>
                ) : null}
                {showTestimonials ? (
                  <li className="flex-none transition-all">
                    <Link className="hover:text-pink-350" to="/testimonials">
                      Testimonials
                    </Link>
                  </li>
                ) : null}
                <li className="flex-none transition-all">
                  <Link className="hover:text-pink-350" to="/contact">
                    Contact us
                  </Link>
                </li>
              </ul>
            </div>
            <div className="flex flex-col basis-1 lg:basis-2/3">
              <h3 className="flex-none uppercase text-lg font-bold text-pink-350 clear-both">
                Services
              </h3>
              <ul className="flex flex-col md:flex-row">
                {menu
                  ? menu.map((service, index) => (
                      <li key={index} className="flex-none pr-0 md:pr-5">
                        <p className="font-semibold uppercase">
                          {service.name}
                        </p>
                        <ul className="flex flex-col my-2">
                          {service.category ? service.category.map((category) => (
                            <li key={category.id + service.id + Math.random()} className="flex-none">
                              <Link
                                reloadDocument
                                className="uppercase hover:text-pink-350 transition-all"
                                to={`/buy-${service.name.toLowerCase()}-${category.name.toLowerCase()}/${service.id}/${category.id}/${category.subcategory[0]?.id}`}
                              >
                                {category.name}
                              </Link>
                            </li>
                          )) : null}
                        </ul>
                      </li>
                    ))
                  : null}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <img className="mx-auto my-5" src={divider} alt="Divider" />
      <footer className="flex flex-row lg:flex-row max-sm:flex-col justify-between lg:justify-between max-sm:justify-center my-5">
        <div className="flex-none">© 2024 DailySocialBoost. All Rights Reserved.</div>
        <div className="flex-none">
          <div className="flex flex-row lg:flex-row max-sm:flex-col justify-end">
            <Link className={`flex-none mx-1 ${styles.footerLink}`} to="/termsOfService">
              Terms of Service
            </Link>
            <Link className={`flex-none mx-1 ${styles.footerLink}`} to="/privacyPolicy">
              Privacy Policy
            </Link>
          </div>
        </div>
      </footer>
    </section>
  );
}
